import { render, staticRenderFns } from "./remove-targets-btn.vue?vue&type=template&id=d74e84c0&"
import script from "./remove-targets-btn.vue?vue&type=script&lang=js&"
export * from "./remove-targets-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports